import { Box, Typography } from '@mui/material'
import { Form, useTranslate } from 'ra-core'
import { useEffect } from 'react'
import { useRecordContext } from 'react-admin'

import { AdvancedDateInput } from '../../components/AdvancedDateTimeInputs'
import AdvancedNumberInput from '../../components/AdvancedNumberInput'
import { getDateFromNow } from '../../utils/dates'

const PlanNextMaintenanceConfirmContent = ({ state, update, isPristine, error }) => {
  const translate = useTranslate()

  const record = useRecordContext()

  useEffect(() => {
    update({
      next_maintenance_mileage: record.next_maintenance_mileage,
      next_maintenance_date: record.next_maintenance_date,
    })
  }, [record]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <Typography sx={{ textAlign: 'justify', mb: 2 }}>
        {translate('resources.vehicles.actions.plan_next_maintenance.helperText')}
      </Typography>

      <Form mode="onBlur">
        <Box>
          <AdvancedNumberInput
            source="next_maintenance_mileage"
            min={0}
            unit="km"
            onChange={(e) =>
              update({ next_maintenance_mileage: e.target.value === '' ? null : Number(e.target.value) })
            }
          />
          <AdvancedDateInput
            minDate={getDateFromNow({ days: 1 })}
            onChange={(e) => {
              if (!e) return update({ next_maintenance_date: null })

              const local = new Date(e)
              const utc = new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate()))
              update({ next_maintenance_date: utc.toISOString() })
            }}
            source="next_maintenance_date"
          />
        </Box>
      </Form>
    </Box>
  )
}

export const PlanNextMaintenanceConfirm = ({ record }) => ({
  content: (props) => <PlanNextMaintenanceConfirmContent {...props} />,
  confirmColor: 'primary',
})
